import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Landing from "@/pages/Landing";
import Diagnostic from "@/pages/Diagnostic";
import Results from "@/pages/Results";
import Owner from "@/pages/Owner";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Journal from "@/pages/Journal";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/diagnostic" element={<Diagnostic />} />
            <Route path="/results/:id" element={<Results />} />
            <Route path="/owner" element={<Owner />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/journal/:id" element={<Journal />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </LanguageProvider>
    </div>
  );
}

export default App;
